module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    class: ['consult-notice', {
      none: _vm.down
    }]
  }, [(_vm.$slots.default) ? [_c('p', {
    staticClass: "tips"
  }, [_vm._t("default")], 2)] : (_vm.TipsType) ? [_c('v-touch', {
    staticClass: "tips not-fiexd",
    attrs: {
      "tag": "p"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.descText)
    },
    on: {
      "tap": _vm.touchEvent
    }
  })] : [_c('v-touch', {
    class: ['tips', _vm.down ? '' : 'slide-down'],
    attrs: {
      "tag": "p"
    },
    on: {
      "tap": _vm.updateOrDownLoadApp
    }
  }, [_vm._v("\n      点击"), _c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(" 下载最新版的APP ")]), _vm._v(" 完成咨询\n    ")])], _vm._v(" "), (_vm.isShowClose) ? _c('v-touch', {
    staticClass: "close",
    on: {
      "tap": _vm.switchDisplay
    }
  }, [_c('i', {
    staticClass: "yxl-font yxl-font-close "
  })]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d4536d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultation/consultNotice.vue
// module id = 2476
// module chunks = 115